import Parse from 'parse';

async function updatePortalUserAction({ id, username, password }) {
  try {

    const userQuery = new Parse.Query('User');
    const user = await userQuery.get(id);

    if (!user) return false;

    user.set('username', username);
    user.set('password', password);

    const result = await user.save();

    return true;

  } catch (error) {
    console.error('updatePortalUserAction error', error);
    return false;
  }
}

export default updatePortalUserAction;
